<!-- <a class="float-end underline cursor-pointer" #modalButton data-bs-toggle="modal" data-bs-target="#form-suscription">
    Suscribirse <i class="fa fa-chevron-right"></i>
</a> -->
<div *ngIf="showSubscriptionBox" class="suscription-box">
    <span class="close-btn" (click)="closeSubscriptionBox()">&times;</span>
    <div class="d-flex align-items-center">
        <img src="assets/img/home/subscribe.png" alt="Suscripción" class="subscription-icon">
        <div class="text text-center">
            <strong style="color: #3b69ae;">¡Suscríbete!</strong>
            <p class="text-start">Recibe nuestras últimas publicaciones y novedades directamente en tu bandeja de entrada.</p>
        </div>
    </div>
    <button class="btn btn-dark ms-3" data-bs-toggle="modal" data-bs-target="#form-suscription">
        Suscribirse
    </button>
</div>

<!-- Alerta del modal -->
<div *ngIf="mensajeOperacion" [ngClass]="['alert', 'modal-message', getAlertClass()]">
    {{ mensajeOperacion }}
</div>

<!-- Modal suscripcion -->
<div #formSuscriptionModal class="modal" id="form-suscription" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content form-color">
            <div class="modal-container">
                <!-- Fondo superior -->
                <div class="modal-header-subs">
                    <a type="button" class="close" data-bs-dismiss="modal" aria-label="Close" style="color: #fff;">
                        <span aria-hidden="true">&times;</span>
                    </a>
                    <div class="form-subs-title">
                        <h3><i class="fa fa-envelope-o" aria-hidden="true"></i> Formulario de suscripción</h3>
                    </div>

                </div>


                <div class="modal-body">
                    <!-- Empieza  formulario -->
                    <form [formGroup]="formSubs" (ngSubmit)="onSubmit()">

                        <div class="form-group">

                            <div class="intro-text">
                                <p>Completa el formulario y no te pierdas ninguna actualización importante.</p>
                            </div>

                            <div class="textOnInput col-md-12">
                                <label class="form-lbl" for="name">Nombre</label>
                                <input id="usernanme" class="form-control form-input" type="text" formControlName="name"
                                    autocomplete="off" [class.is-invalid]="campoNoValido('name')"
                                    [class.is-valid]="!campoNoValido('name') && formSubs.get('name').touched">
                                <small class="text-danger" *ngIf="campoNoValido('name')">
                                    <span *ngIf="name.errors.required">
                                        El nombre es requerido
                                    </span>
                                    <span *ngIf="name.errors.pattern">
                                        Solo se admiten letras
                                    </span>
                                </small>
                            </div>

                            <div class="textOnInput col-md-12">
                                <label class="form-lbl" for="lastname">Apellido paterno</label>
                                <input id="lastname" class="form-control form-input" type="text"
                                    formControlName="lastname" autocomplete="off"
                                    [class.is-invalid]="campoNoValido('lastname')"
                                    [class.is-valid]="!campoNoValido('lastname') && formSubs.get('lastname').touched">
                                <small class="text-danger" *ngIf="campoNoValido('lastname')">
                                    <span *ngIf="lastname.errors.required">
                                        El apellido paterno es requerido
                                    </span>
                                    <span *ngIf="lastname.errors.pattern">
                                        Solo se admiten letras
                                    </span>
                                </small>
                            </div>

                            <div class="textOnInput col-md-12">
                                <label class="form-lbl" for="surname">Apellido materno</label>
                                <input id="surname" class="form-control form-input" type="text"
                                    formControlName="surname" autocomplete="off"
                                    [class.is-invalid]="campoNoValido('surname')"
                                    [class.is-valid]="!campoNoValido('surname') && formSubs.get('surname').touched">
                                <small class="text-danger" *ngIf="campoNoValido('surname')">
                                    <span *ngIf="surname.errors.required">
                                        El apellido materno es requerido
                                    </span>
                                    <span *ngIf="surname.errors.pattern">
                                        Solo se admiten letras
                                    </span>
                                </small>
                            </div>

                            <div class="textOnInput col-md-12">
                                <label class="form-lbl" for="email">Correo electrónico</label>
                                <input id="email" class="form-control form-input" type="email" formControlName="email"
                                    autocomplete="off" [class.is-invalid]="campoNoValido('email')"
                                    [class.is-valid]="!campoNoValido('email') && formSubs.get('email').touched">
                                <small class="text-danger" *ngIf="campoNoValido('email')">
                                    <span *ngIf="email.errors.required">
                                        El correo electrónico es requerido
                                    </span>
                                    <span *ngIf="email.errors.email">
                                        Ingrese un email válido
                                    </span>
                                </small>
                            </div>

                            <div class="form-group col-md-12 my-4 suscription-align">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="subscribeCheckbox"
                                        formControlName="subscribed">
                                    <label class="form-check-label" for="subscribeCheckbox">
                                        Acepta los <a class="underline" (click)="toggleTerms($event)">Términos y
                                            condiciones</a>

                                    </label>
                                </div>
                                <!-- Campo desplegable de términos y condiciones -->
                                <div *ngIf="showTerms" class="terms-and-conditions">
                                    <!-- Contenido de tus términos y condiciones aquí -->
                                    <div style="font-size: 80%; text-align: justify;">
                                        <h4>Acuerdo de Uso de Datos para Suscripciones</h4>
                                        <p>Fecha actual: {{ fechaActual | date:'short' }}</p>
                                        <ol>
                                            <li>
                                                <h5>Información Recopilada:</h5>
                                                <p>Solicitamos cierta información personal, como su nombre y dirección
                                                    de correo electrónico, con el propósito exclusivo de enviarle
                                                    nuestras publicaciones y noticias relevantes.</p>
                                            </li>

                                            <li>
                                                <h5>Uso de la Información:</h5>
                                                <p>La información proporcionada se utilizará únicamente para enviarle
                                                    las publicaciones solicitadas y para mantenerle informado sobre
                                                    eventos y noticias relacionadas con nuestra institución.</p>
                                            </li>

                                            <li>
                                                <h5>Confidencialidad:</h5>
                                                <p>Garantizamos la confidencialidad de su información personal. No
                                                    compartiremos, venderemos ni alquilaremos su información a terceros
                                                    sin su consentimiento expreso.</p>
                                            </li>

                                            <li>
                                                <h5>Seguridad:</h5>
                                                <p>Tomamos medidas razonables para garantizar la seguridad de su
                                                    información. Sin embargo, no podemos garantizar la seguridad
                                                    completa de la información transmitida a través de Internet.</p>
                                            </li>

                                            <li>
                                                <h5>Consentimiento:</h5>
                                                <p>Al proporcionar su información y hacer clic en "Enviar suscripción",
                                                    usted
                                                    otorga su consentimiento para que utilicemos su información de
                                                    acuerdo con los términos establecidos en este acuerdo.</p>
                                            </li>

                                            <li>
                                                <h5>Opciones de Cancelación:</h5>
                                                <p>Usted tiene el derecho de cancelar su suscripción en cualquier
                                                    momento. Cada correo electrónico que reciba incluirá un enlace para
                                                    cancelar la suscripción.</p>
                                            </li>

                                            <li>
                                                <h5>Cambios en la Política:</h5>
                                                <p>Nos reservamos el derecho de modificar esta política en cualquier
                                                    momento. Cualquier cambio se comunicará a través de nuestro sitio
                                                    web.</p>
                                            </li>
                                        </ol>

                                        <p><b>Al proporcionar su información y hacer clic en "Enviar suscripción", usted
                                                indica
                                                que ha leído y comprendido los términos de este acuerdo.</b></p>
                                    </div>


                                </div>
                            </div>


                        </div>

                        <div class="form-group col-md-12 mb-5 text-center">
                            <button class="btn btn-outline-dark btn-sm btn-block" type="submit"
                                [disabled]="formSubs.invalid">
                                Enviar suscripción
                            </button>
                        </div>
                    </form>

                    <!-- Termina formulario -->
                </div>
                <div class="modal-background-bottom"></div> <!-- Fondo inferior -->
            </div>
        </div>
    </div>
</div>